import { createNewHandbookApi } from '@/api/handbookApi'
import { POSITION_PROPERTY_URL } from '@/api/handbook/position'
import { createHandbookResponseErrors } from '@/utils/error/responseErrors'

const WINDING_TYPE_URL = `${POSITION_PROPERTY_URL}/winding-types`

const errors = createHandbookResponseErrors('тип навивки', 'типов навивки')

export const WindingTypeApi = createNewHandbookApi(WINDING_TYPE_URL, errors)
